import { useContext } from "react";
import { ContextPublisherContext } from "./ContextPublisher";

export default function useContextPublisherContext() {
    return useContext(ContextPublisherContext);
};
